import _serialize from 'serialize-javascript';

export default function serialize(input, options = {}) {
  const _options = { ignoreFunction: true, ...options };
  return _serialize(input, _options);
}
